import React, { FC, useContext, useRef } from 'react'
import { Realtime } from 'ably'

const { REACT_APP_ABLY_KEY } = process.env

const AblyContext = React.createContext<Realtime | null>(null)

const AblyProvider: FC = props => {
  const socket = useRef<Realtime | null>(null)
  if (!socket.current && REACT_APP_ABLY_KEY) {
    socket.current = new Realtime(REACT_APP_ABLY_KEY)
  }

  return <AblyContext.Provider value={socket.current} {...props} />
}

function useAbly() {
  const ably = useContext(AblyContext)
  if (!ably) {
    throw new Error('Cannot use `useAbly` outside of AblyProvider')
  }

  return ably
}

export { AblyProvider, useAbly }
